import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { OrderStatus, orderStatusBackground } from './utils/orderStatus';

/**
 * The order's status, worded and coloured from one place: the desktop grid, and the details header
 * for the order a row opens. Clicking a row can therefore never show a status that disagrees with it.
 */
export const OrderStatusChip: React.FC<{ status: OrderStatus }> = ({ status }) => {
  const { t } = useTranslation();

  return (
    <Chip
      label={t(status)}
      sx={{ backgroundColor: (theme) => orderStatusBackground(theme, status), color: 'text.primary' }}
    />
  );
};
